module.exports = ["一带一路","大运河","京津翼","新时代","三个代表","十九大","教育","经济","科技","珠港澳","北京","雾霾","工业","马克思","社会主义"]


//////////////////
// WEBPACK FOOTER
// ./static/json/hot.json
// module id = 0Y9q
// module chunks = 1